import styles from '@fdc/app/styles/global.module.scss';

// BasePageContainer component adds centered page container
function BasePageContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className={styles.layoutwrapper} id="layoutwrapper">
      {children}
    </div>
  );
}

export default BasePageContainer;
